import { AGENTIC_BASE_URL } from "@/services/agentic";
import { getAuthToken } from "@/dataProvider/axios";
import { useAuthStoreV1 } from "@/stores/authStore_v1";
import { httpError } from "@/lib/http/apiError";

export interface PreviousAttempt {
  attempt: number;
  error: string;
  explanation: string | null;
}

export interface ReferenceFile {
  file_name: string;
  content: string;
}

export interface AutoFixRequest {
  code: string;
  error_message: string;
  file_name?: string;
  metadata_type?: string;
  attempt?: number;
  previous_attempts?: PreviousAttempt[];
  org_id?: string;
  /** Other open files' content for context (e.g. class dependencies) */
  reference_files?: ReferenceFile[];
}

export interface AutoFixResponse {
  fixed_code: string;
  explanation: string;
  status: "success" | "error";
  error?: string;
}

export async function requestAutoFix(params: AutoFixRequest): Promise<AutoFixResponse> {
  const userId = useAuthStoreV1.getState().user?.id;
  const res = await fetch(`${AGENTIC_BASE_URL}/api/apex/auto-fix`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getAuthToken()}`,
      ...(params.org_id ? { "X-Organization-ID": params.org_id } : {}),
      ...(userId ? { "X-User-ID": userId } : {}),
    },
    body: JSON.stringify(params),
  });
  if (!res.ok) throw await httpError(res, "apex_auto_fix");
  return res.json();
}
